import { unmask, numberUnmask } from 'utils/unmask';
import blockedPhones from 'utils/blockedPhones';
import blockingEmails from 'utils/blockedEmails';
import includes from 'lodash/includes';

export default {
  clientId: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  requestedAmount: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }
        return Number(unmask(input)) < 1000 || Number(unmask(input)) > 50000 ? 'Requested Amount not in range' : true;
      },
    },
  ],
  firstName: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  lastName: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  streetAddress: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  city: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  state: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  zip: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  phone: [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      return (
        numberUnmask(input).length < 10
          || blockedPhones.indexOf(input || '') !== -1
      ) ? 'Phone number is not valid' : true;
    },
  }],
  email: [
    'email',
    {
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }

        return blockingEmails.includes(`${input}`.toLowerCase()) ? 'Email is not valid' : true;
      },
    },
  ],
  grossMonthlyIncome: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  bankruptcy: [{
    isValid: (input) => {
      if (!includes([true, false, 'true', 'false'], input)) {
        return 'The input field is required';
      }
      return true;
    },
  }],
  financialHardship: [{
    isValid: (input) => {
      if (!includes([true, false, 'true', 'false'], input)) {
        return 'The input field is required';
      }
      return true;
    },
  }],
  rentOrOwn: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  monthlyHousingPayment: [{
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }
      return true;
    },
  }],
  currentWithMortgage: [{
    isValid: (input, error, opt, values) => {
      if (values.rentOrOwn === 'Own') {
        if (!input) {
          return 'The input field is required';
        }
      }
      return true;
    },
  }],
  carPayment: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  monthlyCarPayment: [{
    isValid: (input, error, opt, values) => {
      if (values.carPayment !== 'false' && values.carPayment !== false) {
        if (!input) return 'The input field is required';
      }
      return true;
    },
  }],
  currentWithCarPayment: [{
    isValid: (input, error, opt, values) => {
      if (values.carPayment !== 'false') {
        if (!includes([true, false, 'true', 'false'], input)) {
          return 'The input field is required';
        }
      }
      return true;
    },
  }],
};



// WEBPACK FOOTER //
// ./src/containers/pages/PreSelection/Start/schema.js